import React, { useEffect } from 'react';
import PageShell from '../common/PageShell.jsx';
import PageHero from '../common/PageHero.jsx';

const Services = () => {
  useEffect(() => {
    document.title = 'Products | Eco World Capital';
  }, []);

  const investmentSolutions = [
    { title: 'Demat and Trading Account Assistance', desc: 'We assist clients in opening Demat and trading accounts through reputed financial institutions and brokerage partners, enabling seamless participation in capital markets.' },
    { title: 'Portfolio Management Support', desc: 'We provide portfolio monitoring, market research support, and investment strategy assistance designed to help clients optimize their investment decisions.' },
    { title: 'Account Handling Support', desc: 'EWC offers technology-enabled account monitoring and execution support through systematic and disciplined trading methodologies, subject to applicable regulations and client agreements. *Subject to applicable regulatory requirements and approvals if require.' },
    { title: 'Algorithmic Trading Solutions', desc: 'We provide advanced algorithmic trading systems that utilize predefined rules, automation, and data-driven execution methodologies to minimize emotional decision-making and improve operational efficiency.' },
  ];

  const softwareOfferings = ['Lease-based Trading Software', 'Rental Trading Software', 'Outright Software Purchase', 'Customized Trading Automation Solutions'];

  const softwareMarkets = ['Equity Markets', 'Futures & Options', 'Commodities Markets', 'Currency Markets', 'International Financial Markets'];

  const loanCategories = ['Business Loans', 'Working Capital Finance', 'Personal Loans', 'Home Loans', 'Mortgage Loans', 'Loan Against Property', 'MSME Financing', 'Customized Funding Solutions'];

  return (
    <PageShell>
      <PageHero
        badge="Core Business Areas"
        title="Products and Services"
        subtitle="EWC offers Financial Services, Investment Facilitation, Financial Technology Solutions, Loan Arrangement Services, and Algorithmic Trading Solutions."
      />

      <section className="py-24 px-6 md:px-12 bg-black/10 border-y border-white/20 backdrop-blur-sm">
        <div className="max-w-6xl mx-auto">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-extrabold text-brand-cream">Investment & Trading Solutions</h2>
          </div>

          <div className="grid md:grid-cols-2 gap-8">
            {investmentSolutions.map((item, idx) => (
              <div key={idx} className="glass-card p-8 shimmer-hover">
                <div className="relative z-10">
                  <h3 className="text-2xl font-extrabold text-brand-gold tracking-wide mb-4">{item.title}</h3>
                  <p className="text-base text-brand-cream-muted leading-relaxed font-medium">{item.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="py-24 px-6 md:px-12 max-w-6xl mx-auto">
        <div className="grid md:grid-cols-2 gap-16 items-start">
          <div>
            <span className="section-badge mb-6">Financial Technology</span>
            <h2 className="text-4xl font-extrabold text-brand-cream mb-6">Trading Software Solutions</h2>
            <p className="text-brand-cream-muted text-lg leading-relaxed font-medium mb-8">
              We facilitate technology-driven platforms designed to give you a competitive edge.
            </p>

            <div className="glass-card p-8 mb-8">
              <h3 className="text-xl font-bold text-brand-gold mb-4 border-b border-brand-cream/20 pb-2">We Facilitate:</h3>
              <ul className="space-y-4">
                {softwareOfferings.map((offering, idx) => (
                  <li key={idx} className="flex items-center space-x-3 text-brand-cream font-medium">
                    <span className="text-brand-gold-light font-black">✓</span>
                    <span>{offering}</span>
                  </li>
                ))}
              </ul>
            </div>
          </div>

          <div className="glass-card p-10 mt-4 md:mt-24 relative overflow-hidden">
            <div className="absolute top-0 left-0 w-full h-1/2 bg-gradient-to-b from-brand-cream/20 to-transparent pointer-events-none" aria-hidden="true" />
            <h3 className="text-2xl font-bold text-brand-gold-light mb-6 border-b border-brand-cream/20 pb-4 relative z-10">Suitable For:</h3>
            <ul className="space-y-5 relative z-10">
              {softwareMarkets.map((market, idx) => (
                <li key={idx} className="flex items-center space-x-4 text-brand-cream font-medium text-lg">
                  <span className="text-brand-primary bg-gradient-to-br from-brand-gold to-brand-gold-light w-8 h-8 rounded-lg flex items-center justify-center shadow-inner font-black text-sm shrink-0">
                    ✦
                  </span>
                  <span>{market}</span>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </section>

      <section className="py-24 px-6 md:px-12 bg-black/10 border-y border-white/20 backdrop-blur-sm">
        <div className="max-w-6xl mx-auto">
          <div className="text-center mb-16 max-w-3xl mx-auto">
            <h2 className="text-4xl font-extrabold text-brand-cream mb-6">Loan Arrangement Services</h2>
            <p className="text-brand-cream-muted text-lg leading-relaxed font-medium">
              EWC assists individuals and businesses in arranging suitable financing solutions through its network of financial institutions and lending partners. Our objective is to help clients identify financing options that align with their business and personal financial requirements.
            </p>
          </div>

          <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-4 mb-12">
            {loanCategories.map((loan, idx) => (
              <div key={idx} className="glass-card p-5 rounded-2xl hover:bg-brand-cream/20 hover:border-brand-gold-light/40 transition-all flex items-center space-x-4 shadow-md group">
                <span className="text-brand-primary text-xl bg-gradient-to-br from-brand-gold to-brand-gold-light w-10 h-10 rounded-xl flex items-center justify-center shadow-inner font-black group-hover:scale-110 transition-transform">
                  ✦
                </span>
                <span className="text-sm font-bold text-brand-cream tracking-wide">{loan}</span>
              </div>
            ))}
          </div>

          <div className="bg-gradient-to-r from-brand-gold/20 to-brand-gold-light/10 p-6 rounded-2xl border border-brand-gold/40 text-center">
            <p className="text-brand-cream font-semibold text-lg">
              We accept / arrange and provides Private Equity and Venture Capital as per JVA terms and conditions.
            </p>
          </div>
        </div>
      </section>
    </PageShell>
  );
};

export default Services;
